module.exports = __webpack_public_path__ + "static/media/gp.0b958f6c.svg";